import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import StoreProvider from './store/Provider';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <StrictMode>
    <StoreProvider>
      <App />
    </StoreProvider>
  </StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
